import { createSlice } from '@reduxjs/toolkit'
import { activateUser, changePassword, checkJwtToken, forgotPassword, updatePassword, updateProfile, userLogin } from '../actions/userAction'

export const user = createSlice({
  name: 'user',
  initialState: {
    isClientLoggedIn: false,
    userDetail: null,
    error: null,
    isLoader: false,
    isHiden: true,
    isRecordAdded: false,
    isRecordUpdated: false,
    invalidJwtToken: false,
  },
  reducers: {
    checkUser: (state, {payload}) => {
      state.isClientLoggedIn = payload?true:false
      state.userDetail= JSON.parse(payload);
    },
    userManage: state => {
      state.isClientLoggedIn = true
    },
    userReset: state => {
        // state.isClientLoggedIn = false;
        // state.userDetail = null;
        state.error = null;
        state.isLoader = false;
        state.isRecordAdded = false;
        state.isRecordUpdated = false;
      },
    resetError: state => {
        state.error = null;
        state.isLoader = false;
      },
      toggleHide: state => {
        state.isHiden = !state.isHiden;
      },   
  },
  extraReducers: {
    [userLogin.pending]: (state, payload) => {
      state.isClientLoggedIn= false;
      state.userDetail= payload.data;
    },
    [userLogin.fulfilled]: (state, {payload}) => {
      state.isClientLoggedIn= true;
      state.userDetail= payload?.data;
    },
    [userLogin.rejected]: (state, {payload}) => {
      state.isClientLoggedIn= false;
      state.error= payload;
    },
    [updateProfile.pending]: (state, payload) => {
      state.isLoader = true;
    },
    [updateProfile.fulfilled]: (state, {payload}) => {
      state.userDetail= payload?.data;
      state.isLoader = false;
      state.isRecordUpdated = true;
    },
    [updateProfile.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader = false;
    },
    [activateUser.pending]: (state, payload) => {
      state.isLoader = true;
    },
    [activateUser.fulfilled]: (state, {payload}) => {
      // state.userDetail= payload?.data;
      state.isLoader = false;
      state.isRecordAdded = true;
    },
    [activateUser.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader = false;
    },
    [forgotPassword.pending]: (state, payload) => {
      state.isLoader = true;
    },
    [forgotPassword.fulfilled]: (state, {payload}) => {
      state.isLoader = false;
      state.isRecordAdded = true;
    },
    [forgotPassword.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader = false;
    },
    [changePassword.pending]: (state, payload) => {
      state.isLoader = true;
    },
    [changePassword.fulfilled]: (state, {payload}) => {
      state.isLoader = false;
      state.isRecordUpdated = true;
    },
    [changePassword.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader = false;
    },
    [updatePassword.pending]: (state, payload) => {
      state.isLoader = true;
    },
    [updatePassword.fulfilled]: (state, {payload}) => {
      state.isLoader = false;
      state.isRecordAdded = true;
    },
    [updatePassword.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader = false;
    },
    [checkJwtToken.pending]: (state, payload) => {
      // state.isClientLoggedIn= false;
    },
    [checkJwtToken.fulfilled]: (state, {payload}) => {
      state.invalidJwtToken = false;
    },
    [checkJwtToken.rejected]: (state, {payload}) => {
      state.invalidJwtToken = true;
    },
  }
})

// Action creators are generated for each case reducer function
export const { userManage, userReset, checkUser, resetError, toggleHide } = user.actions

export default user.reducer